import {
  DeesElement,
  property,
  state,
  html,
  customElement,
  type TemplateResult,
  cssManager,
  css,
  unsafeHTML,
} from '@design.estate/dees-element';

import * as domtools from '@design.estate/dees-domtools';
import * as lointPubapi from '@losslessone_private/loint-pubapi';

@customElement('lossless-section-projects')
export class LosslessSectionProjects extends DeesElement {
  @state()
  public projects: lointPubapi.IRequest_Any_Pubapi_GetProjects['response']['projects'] = [];

  constructor() {
    super();
  }

  public static styles = [
    cssManager.defaultStyles,
    css`
      :host {
        display: block;
        padding-bottom: 40px;
        background: ${cssManager.bdTheme('#eeeeeb', '#000')};
        border-top: 1px solid ${cssManager.bdTheme('#ddd', '#222')};
        border-bottom: 1px solid ${cssManager.bdTheme('#ddd', '#222')};
        border-image: radial-gradient(#88888870, #88888800) 1;
      }
      .sectionContainer {
        position: relative;
        padding: 40px 0px 40px 0px;
        min-height: 300px;
        color: var(--lelecv-color-font);
        display: block;
        border-bottom: 1px solid ${cssManager.bdTheme('#ddd', '#222')};
      }

      .sectionContainer:last-child {
        border-bottom: none;
      }

      .sectionHeading {
        text-align: center;
        max-width: var(--lelecv-pagewidth, 1200px);
        margin: auto;
      }

      .sectionHeading h1 {
        font-family: 'Cal Sans', 'Inter', sans-serif;
        letter-spacing: 0.025em;
        font-size: 24px;
        font-weight: 500;
        margin: 0px;
      }

      .sectionHeading h1 span {
        color: ${cssManager.bdTheme('#666', '#CCC')};
      }

      .sectionHeading::after {
        display: block;
        margin: auto;
        margin-top: 8px;
        margin-bottom: 8px;
        border-radius: 6px;
        width: 32px;
        height: 4px;
        background: var(--lelecv-color-accent);
        content: '';
      }

      .sectionDescription {
        text-align: center;
        margin: auto;
        margin-top: 8px;
        margin-bottom: 32px;
        max-width: 650px;
        font-size: 16px;
        font-family: 'Geist Sans', sans-serif;
        font-weight: 400;
        line-height: 1.5em;
      }

      .sectionBoxItems {
        display: grid;
        max-width: var(--lelecv-pagewidth);
        margin: auto;
        grid-template-columns: ${cssManager.cssGridColumns(8, 16)};
        grid-column-gap: 16px;
        grid-row-gap: 16px;
      }

      ${cssManager.cssForNotebook(css`
        .sectionBoxItems {
          padding-left: 40px;
          padding-right: 40px;
          grid-template-columns: ${cssManager.cssGridColumns(4, 16)};
        }
      `)}
      ${cssManager.cssForTablet(css`
        .sectionDescription {
          padding-left: 40px;
          padding-right: 40px;
        }
        .sectionBoxItems {
          grid-template-columns: ${cssManager.cssGridColumns(3, 16)};
        }
      `)}
      ${cssManager.cssForPhablet(css`
        .sectionDescription {
          padding-left: 32px;
          padding-right: 32px;
        }
        .sectionBoxItems {
          padding-left: 32px;
          padding-right: 32px;
          grid-template-columns: ${cssManager.cssGridColumns(2, 16)};
        }
      `)}
          ${cssManager.cssForPhone(css`
        .sectionBoxItems {
          grid-template-columns: 100%;
        }
      `)}
          .sectionBox {
        display: block;
      }

      .projectTile {
        will-change: transform;
        background: ${cssManager.bdTheme('#383838', '#181818')};
        border-radius: 16px;
        transition: all 0.2s;
      }

      .projectTile:hover {
        transform: scale(1.05, 1.05);
      }

      .buttonGroup {
        margin: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ];

  public render(): TemplateResult {
    return html`
      <div class="sectionContainer">
        <div class="sectionHeading">
          <h1>Any <span>Data,</span> Continuous <span>Insights</span></h1>
        </div>
        <div class="sectionDescription">
          Pipe any data into lossless.com, let your code and AI decide what goes into the vault, and for how long it is retained. Set data as immutable, and search across everything.
        </div>
        <div class="sectionBoxItems">
          ${this.projects
            .filter((projectArg) => {
              return projectArg.category === 'SaaS' || projectArg.category === 'IaaS';
            })
            .map((projectArg) => {
              return html`
                <div class="sectionBox">
                  <div class="projectTile">
                    <a href="${projectArg.url}">
                      <img src="${projectArg.logoUrlSquared}" />
                    </a>
                  </div>
                </div>
              `;
            })}
        </div>
        <div class="buttonGroup">
          <dees-button>Get Started</dees-button>
        </div>
      </div>
    `;
  }
}
